module.exports = __webpack_public_path__ + "media/put3.4d5081df.mp4";